<div
  class="menu-container"
  [class.menu-container-on-top]="isScrolledToTop$ | async"
  *tuiLet="languageService.currentLanguage$ | async as language"
>
  <app-header-action class="menu-container-mobile-menu-toggle">
    <tui-svg
      (click)="toggleMobileNavigation()"
      [src]="expanded ? 'tuiIconCloseLarge' : 'tuiIconMenuLarge'"
    ></tui-svg>
  </app-header-action>

  <div class="menu-container-navigation-wrapper">
    <a
      (click)="closeMobileNavigation()"
      [routerLink]="['/', language]"
      class="menu-container-navigation-wrapper-logo"
    >
      <ng-container *ngIf="headerLogo$ | async as headerLogo">
        <img [src]="headerLogo | imageVariant: {width: 256, height: 256}" />
      </ng-container>
    </a>
    <ng-container *ngFor="let link of links$ | async">
      @if (!link.hidden && (!link.hidden$ || (link.hidden$ | async) === false)) { @if
      (link.routerLink) {
      <a
        class="menu-container-navigation-wrapper-navigation-links"
        [routerLink]="['/', language, link.routerLink]"
        routerLinkActive="active-link"
      >
        {{ link.label | translate }}
      </a>
      } @else {
      <a class="menu-container-navigation-wrapper-navigation-links" [href]="link.href">
        {{ link.label | translate }}
      </a>
      } }
    </ng-container>
  </div>

  <div class="menu-container-actions-wrapper">
    <div class="menu-container-actions-wrapper-elements">
      <app-header-action class="menu-container-actions-wrapper-elements-search">
        <a [routerLink]="['/', language, RouteNames.search]">
          <tui-svg src="tuiIconSearchLarge"></tui-svg>
        </a>
      </app-header-action>
      <app-header-action class="menu-container-actions-wrapper-elements-language-picker">
        <app-language-picker
          (languageChanged)="changeLanguage($event)"
        ></app-language-picker>
      </app-header-action>

      <ng-container *ngIf="wicketLoginEnabled">
        <ng-container *tuiLet="user$ | async as user">
          <ng-container *ngIf="!user; else userProfileButton">
            <!-- This two buttons are show and hidden in css depending on the screen size, so ony one is visible at any time -->
            <button
              tuiButton
              class="login-button"
              size="m"
              type="button"
              appearance="primary"
              (click)="login()"
              [showLoader]="isLoadingUser$ | async"
            >
              {{ 'header.login' | translate }}</button
            ><button
              tuiButton
              class="login-button"
              size="l"
              type="button"
              appearance="primary"
              (click)="login()"
              [showLoader]="isLoadingUser$ | async"
            >
              {{ 'header.login' | translate }}
            </button>
          </ng-container>

          <ng-template #userAvatar>
            <tui-avatar
              [rounded]="true"
              [avatarUrl]="
                getUserAvatar(user) ??
                'https://ekstraklasa-frontend-assets.s3.eu-central-1.amazonaws.com/images/default_avatar.png'
              "
            ></tui-avatar>
          </ng-template>
          <ng-template #userProfileButton>
            <button
              tuiIconButton
              [icon]="userAvatar"
              type="button"
              appearance="flat"
              size="l"
              (click)="goToUserProfile()"
            ></button>
          </ng-template>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<tui-expand class="mobile-nav" [expanded]="expanded">
  <ng-template
    tuiExpandContent
    *tuiLet="languageService.currentLanguage$ | async as language"
  >
    <div class="mobile-navigation-wrapper">
      <div class="mobile-navigation-links">
        <ng-container *ngFor="let link of links$ | async">
          <a
            (click)="closeMobileNavigation()"
            class="mobile-navigation-link"
            [routerLink]="['/', language, link.routerLink]"
            *ngIf="!link.hidden && (!link.hidden$ || (link.hidden$ | async) === false)"
            routerLinkActive="active-link"
          >
            {{ link.label | translate }}
          </a>
        </ng-container>
        <a
          (click)="closeMobileNavigation()"
          class="mobile-navigation-link"
          [routerLink]="['/', language, RouteNames.search]"
          routerLinkActive="active-link"
        >
          {{ 'header.search' | translate }}
        </a>
      </div>
      <div class="language-picker-wrapper">
        <app-language-picker
          (languageChanged)="changeLanguage($event)"
        ></app-language-picker>
      </div>
      <div class="help-email-wrapper">
        <span> {{ 'footer.help' | translate }} {{ 'footer.contact' | translate }} </span>

        <a [href]="'mailto:' + ('footer.email' | translate)" class="notranslate">
          {{ 'footer.email' | translate }}
        </a>
      </div>
    </div>
  </ng-template>
</tui-expand>
<canvas
  *ngIf="expanded"
  class="expanded-view-background"
  (click)="closeMobileNavigation()"
>
</canvas>
